module.exports = __webpack_public_path__ + "img/img55.bf74ff55.png";